<template>
  <b-modal
    :id="modalId"
    :title="modalTitle"
    ok-title="Guardar"
    cancel-title="Cancelar"
    @ok="handleSubmit"
    @hidden="resetForm"
  >
    <b-form @submit.prevent="handleSubmit">
      <b-form-group label="Número del Salón">
        <b-form-input
          v-model="form.numero"
          placeholder="Ej: 101"
          required
        />
      </b-form-group>
      <b-form-group label="Edificio" class="mt-1">
        <b-form-select
          v-model="form.edificioId"
          :options="buildingsOptions"
          required
        />
      </b-form-group>
      <b-form-group label="Capacidad" class="mt-1">
        <b-form-input
          v-model.number="form.capacidad"
          type="number"
          placeholder="Ej: 30"
          required
        />
      </b-form-group>
      <b-form-group label="Capacidad Máxima" class="mt-1">
        <b-form-input
          v-model.number="form.capacidadMaxima"
          type="number"
          placeholder="Ej: 35"
          required
        />
      </b-form-group>
      <b-form-group label="Estado" class="mt-1">
        <b-form-select
          v-model="form.estado"
          :options="statusOptions"
          required
        />
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
import { BModal, BForm, BFormGroup, BFormInput, BFormSelect, BFormTags } from 'bootstrap-vue'

export default {
  components: {
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormTags,
  },
  props: {
    classroomData: {
      type: Object,
      default: null,
    },
    buildings: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      modalId: 'classroom-modal',
      form: {
        salonId: null,
        numero: '',
        edificioId: null,
        capacidad: null,
        capacidadMaxima: null,
        estado: true,
      },
      statusOptions: [
        { text: 'Activo', value: true },
        { text: 'Inactivo', value: false }
      ],
    }
  },
  computed: {
    modalTitle() {
      return this.form.salonId ? 'Editar Salón' : 'Nuevo Salón'
    },
    buildingsOptions() {
      return this.buildings.map(b => ({ value: b.edificioId, text: b.nombre }))
    },
  },
  watch: {
    classroomData(newData) {
      if (newData) {
        this.form = { ...newData }
      } else {
        this.resetForm()
      }
    },
  },
  methods: {
    handleSubmit() {
      this.$emit('submit', { ...this.form })
      this.$bvModal.hide(this.modalId)
    },
    resetForm() {
      this.form = {
        salonId: null,
        numero: '',
        edificioId: null,
        capacidad: null,
        capacidadMaxima: null,
        estado: true,
      }
    },
  },
}
</script>
